import { useState, useEffect } from 'react'

export function useBrowser() {
	const [ isSafari, setIsSafari ] = useState<boolean>( null )
	useEffect( () => {
		// https://stackoverflow.com/a/9851769/801042
		setIsSafari(
			// @ts-ignore
			// eslint-disable-next-line max-len
			/constructor/i.test( window.HTMLElement ) || ( function( p ) { return p.toString() === '[object SafariRemoteNotification]' })( !window[ 'safari' ] || ( typeof safari !== 'undefined' && safari.pushNotification ) )
		)
	}, [] )

	return { isSafari }
}
